import { Button, Col, Row } from "react-bootstrap";
import StateMonthlyPriceChart from "../charts/stateMonthlyPriceChart";

const multiCharts = (list, heading) => (
  <Row className="mt-3">
    <br />
    <h3>{heading}</h3>
    {list.map((stateName, index) => (
      <Col sm={6} key={index}>
        <StateMonthlyPriceChart stateName={stateName} />
      </Col>
    ))}
  </Row>
);

const RateClassifications = [
  { name: "All", isSelected: true, value: "" },
  { name: "Residential", value: "Residential" },
  { name: "Small Commercial", value: "Small Commercial" },
  { name: "Medium Commercial", value: "Medium Commercial" },
  { name: "Large Commercial", value: "Large Commercial" },
  { name: "Street Lighting", value: "Street Lighting" },
];

const colorsList = [
  "#FF5733",
  "#33FF57",
  "#3357FF",
  "#FF33A1",
  "#FFDD33",
  "#33FFF7",
  "#9D33FF",
  "#FF8333",
  "#33FFD4",
  "#FF5733",
];

const termsToPlotToPlot = [
  "3M Term for Last 12 Months",
  "6M Term for Last 12 Months",
  "12M Term for Last 12 Months",
  "24M Term for Last 12 Months",
  "36M Term for Last 12 Months",
];

const statesToPlot = [
  "Texas",
  "California",
  "Toronto",
  "New York",
  "New Jersey",
];

const profilesToPlot = [
  "Texas",
  "California",
  "Toronto",
  "New York",
  "New Jersey",
];

const prevYearPricingToPlot = ["12 Month Pricing"];

const tabOptions = [
  {
    id: 1,
    name: "Term Based Pricing",
    component: multiCharts(termsToPlotToPlot, "Term Based Pricing"),
    isSelected: true,
  },
  {
    id: 11,
    name: "Term Based Pricing (v2)",
    component: multiCharts(termsToPlotToPlot, "Term Based Pricing"),
    isSelected: true,
  },
  {
    id: 2,
    name: "12 Month Pricing",
    component: multiCharts(prevYearPricingToPlot, "12 Month Pricing"),
  },
  {
    id: 3,
    name: "Profile Based Pricing",
    component: multiCharts(
      RateClassifications.map((item) => item.name),
      "Profile Based Pricing"
    ),
  },
  {
    id: 4,
    name: "State Wise Pricing",
    component: multiCharts(statesToPlot, "Statewise Pricing"),
  },
];

const defaulCategories = [
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
  "Jan",
  "Feb",
];
const defaultSeries = [
  {
    name: "Engie",
    data: [45, 52, 38, 24, 33, 26, 21, 20, 16, 18, 15, 20],
  },
  {
    name: "Supplier A",
    data: [35, 41, 52, 42, 13, 18, 29, 27, 31, 44, 42, 35],
  },
  {
    name: "Supplier B",
    data: [45, 50, 35, 20, 35, 25, 25, 25, 65, 28, 18, 30],
  },
  {
    name: "Supplier C",
    data: [35, 31, 62, 42, 23, 18, 29, 37, 38, 51, 32, 35],
  },
  {
    name: "Supplier D",
    data: [45, 45, 45, 65, 45, 35, 45, 45, 43, 45, 42, 40],
  },
];

const termsOptions = [
  { name: "All", isSelected: true, value: "" },
  { name: "6 Months", value: "6" },
  { name: "12 Months", value: "12" },
  { name: "24 Months", value: "24" },
  { name: "36 Months", value: "36" },
  { name: "48 Months", value: "46" },
];

const productTypeOptions = [
  { name: "Fixed", value: "Fixed" },
  { name: "Index", value: "Index" },
  { name: "NYMEX", value: "NYMEX" },
];

// TODO: remove unnecessary imports and unused variables
export {
  RateClassifications,
  colorsList,
  termsToPlotToPlot,
  statesToPlot,
  profilesToPlot,
  prevYearPricingToPlot,
  tabOptions,
  defaultSeries,
  defaulCategories,
  termsOptions,
  productTypeOptions,
};
